<template functional>
  <div
    :class="[
      $style.badge,
      props.disabled && $style.disabled
    ]"
  >
    {{ props.text }}
  </div>
</template>

<style lang="scss" module>

.badge {
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  padding: 5px;
  background-color: rgba(231, 50, 115, 0.6);
  display: inline-block;
  border-radius: 5px;

  &.disabled {
    background-color: rgba(152, 152, 152, 0.6);
  }
}
</style>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
